import React from "react";
import {
  Box,
  Stack,
  Dialog,
  Button,
  TextField,
  DialogTitle,
  DialogContent,
  Grid,
  Typography,
} from "@mui/material";
import CancelRoundedIcon from "@mui/icons-material/CancelRounded";

const AreaForm = ({
  open,
  formValue,
  isDisabled,
  errorMessage,
  handleClose,
  handleInputChange,
  findDuplicateArea,
}) => {
  return (
    <>
      <Dialog fullWidth open={open} onClose={handleClose}>
        <Box className="flex justify-between">
          <DialogTitle className="text-[#312C41] !text-[16px] !font-semibold">
            {!formValue?.id ? "Create" : "Edit"} Area
          </DialogTitle>

          <CancelRoundedIcon
            onClick={handleClose}
            className="bg-[white] !text-[#344767] !text-[1.7rem] !outline-none p-4 cursor-pointer"
          />
        </Box>

        <DialogContent>
          <Stack spacing={4}>
            <Grid item>
              <TextField
                required
                fullWidth
                name="name"
                type="text"
                id="outlined-required"
                label="Area Name"
                size="small"
                value={formValue.name}
                onChange={handleInputChange}
              />
            </Grid>
            <Grid item>
              <TextField
                required
                fullWidth
                name="description"
                type="text"
                id="outlined-required"
                label="Description"
                size="small"
                value={formValue.description}
                onChange={handleInputChange}
              />
            </Grid>

            <Typography variant="subtitle2" className="text-[#DD2121]">
              {errorMessage}
            </Typography>

            <Button
              disabled={!isDisabled}
              onClick={findDuplicateArea}
              sx={{
                textTransform: "none",
                background: !isDisabled
                  ? "gray"
                  : "linear-gradient(135deg, #3A416F 0%, #141727 100%)",
                color: "white",
                "&:hover": {},
              }}
            >
              {formValue?.id ? "Update" : "Submit"}
            </Button>
          </Stack>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default AreaForm;
